import { Component } from '@angular/core';
import { ActivatedRoute, Data, Router } from '@angular/router';

import { HistoricoConciliacao } from '../models/historico-conciliacao';
import { ImportLancamentosService } from '@services/import-lancamentos.service';
import { OrigemLancamento } from '@models/enums/origem-lancamento';
import { HistoricoConciliacaoApiService } from '../services/historico-conciliacao-api.service';
import { MatDialog } from '@angular/material/dialog';
import { ReconciliarLancamentosDialogComponent } from './reconciliar-lancamentos-dialog/reconciliar-lancamentos-dialog.component';
import { EscolherLoteImportacaoDialogComponent } from './escolher-lote-importacao-dialog/escolher-lote-importacao-dialog.component';
import { DesfazerImportacaoDialogComponent } from './desfazer-importacao-dialog/desfazer-importacao-dialog.component';
import { Permissao } from '@models/enums/permissao';
import { PermissionService } from '@services/permission.service';
import { TipoContaBancoEnum } from '@models/enums/tipo-conta-banco-enum';

@Component({
  selector: 'app-historico-conciliacao',
  standalone: false,
  templateUrl: './historico-conciliacao.component.html',
  styleUrl: './historico-conciliacao.component.scss'
})
export class HistoricoConciliacaoComponent {

  protected get permissaoExportarConciliacao() { return Permissao.EXPORTAR_CONCILIACAO; }
  protected get permissaoImportarExtrato() { return Permissao.IMPORTAR_EXTRATO; }
  protected get permissaoEditarConciliacao() { return Permissao.EDITAR_CONCILIACAO; }
  protected get permissaoDesfazerImportacao() { return Permissao.DESFAZER_IMPORTACAO_LANCAMENTOS_BANCO; }
  protected get podeEditarConciliacao(): boolean {
    return this.permissionService.has(Permissao.EDITAR_CONCILIACAO);
  }

  titulo: string = "Historico de Conciliações";
  historicoConciliacao: HistoricoConciliacao;

  excelFileType: string = ".xlsx";
  csvFileType: string = ".csv";
  origemLancamentoBanco: OrigemLancamento = OrigemLancamento.Banco;
  tipoContaBancoCartao: TipoContaBancoEnum = TipoContaBancoEnum.CartaoCredito;

  constructor(
    private importConciliacaoService: ImportLancamentosService,
    private historicoConciliacaoApiService: HistoricoConciliacaoApiService,
    private route: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
    private permissionService: PermissionService,
  ) { }

  ngOnInit(): void {
    this.route.data.subscribe((data: Data) => {
      this.historicoConciliacao = data['historicoConciliacao'];
      this.titulo += ` do ${this.historicoConciliacao.nomeBanco}`
    });
  }

  public editarConciliacao(index: number): void {
    const conciliacaoId = this.historicoConciliacao.conciliacoes[index].id;

    const httpUrl = `/conciliacao/editar/${conciliacaoId}`;
    this.router.navigateByUrl(httpUrl);
  }

  public importLancamentos(inputElement: HTMLInputElement): void {
    this.importConciliacaoService.importLancamentos(
      inputElement, this.historicoConciliacao.contaBancoId, this.origemLancamentoBanco, this.historicoConciliacao.tipoContaBanco);
  }

  public exportarConciliacao(index: number): void {
    const conciliacao = this.historicoConciliacao.conciliacoes[index];
    this.historicoConciliacaoApiService.exportarConciliacao(this.historicoConciliacao, conciliacao);
  }

  public reconciliarLancamentosClick(): void {
    const dialogRef = this.dialog.open(ReconciliarLancamentosDialogComponent, {
      width: '600px',
      panelClass: 'no-padding-dialog',
      autoFocus: false,
      disableClose: true
    });
    dialogRef.componentInstance.contaBancoId = this.historicoConciliacao.contaBancoId;

    // dialogRef.afterClosed().subscribe((salvo: boolean | undefined) => {
    //   if (salvo)
    //     this.reloadPage();
    // });
  }

  public desfazerImportacaoClick(): void {
    if (this.historicoConciliacao.tipoContaBanco === this.tipoContaBancoCartao) {
      this.abrirEscolherLoteImportacaoDialog();
      return;
    }

    this.abrirDesfazerImportacaoDialog();
  }

  private abrirEscolherLoteImportacaoDialog(): void {
    const dialogRef = this.dialog.open(EscolherLoteImportacaoDialogComponent, {
      width: '900px',
      maxWidth: '90vw',
      panelClass: 'no-padding-dialog',
      autoFocus: false,
      disableClose: true
    });
    dialogRef.componentInstance.contaBancoId = this.historicoConciliacao.contaBancoId;

    dialogRef.afterClosed().subscribe((loteImportacaoBancoId: number | undefined) => {
      if (loteImportacaoBancoId)
        this.abrirDesfazerImportacaoDialog(loteImportacaoBancoId);
    });
  }

  private abrirDesfazerImportacaoDialog(loteImportacaoBancoId?: number): void {
    const dialogRef = this.dialog.open(DesfazerImportacaoDialogComponent, {
      width: '900px',
      maxWidth: '90vw',
      panelClass: 'no-padding-dialog',
      autoFocus: false,
      disableClose: true
    });
    dialogRef.componentInstance.contaBancoId = this.historicoConciliacao.contaBancoId;
    dialogRef.componentInstance.loteImportacaoBancoId = loteImportacaoBancoId;

    dialogRef.afterClosed().subscribe((desfeito: boolean | undefined) => {
      if (desfeito)
        this.reloadPage();
    });
  }

  private reloadPage(): void {
    this.historicoConciliacaoApiService.getContasBanco(this.historicoConciliacao.contaBancoId)
      .subscribe(historico => this.historicoConciliacao = historico);
  }
}
